export default "__VITE_ASSET__XK2plgF5__"